export const host="https://chat-app-server-opal.vercel.app";
export const registerRoute= `${host}/api/auth/register`;
export const loginRoute= `${host}/api/auth/login`;
export const AllUsersRoute= `${host}/api/auth/alluser`;
export const sendMsg= `${host}/api/msg/addmsg`;
export const getMsg= `${host}/api/msg/getmsg`;


